export const DGE_OPERATOR_GROUP = 'ARENA' as const
